import classNames from 'classnames';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { UiTypographyProps } from '@/components/ui/Typography/types';

import './Title.scss';

interface Props {
  className?: string;
  children: NonNullable<React.ReactNode>;
  color?: UiTypographyProps['color'];
  TEST_ID?: string;
}

export const OnboardingTitle = React.forwardRef<
  HTMLElement,
  React.PropsWithChildren<Props>
>(function Title({ children, className, TEST_ID, color = 'black' }, ref) {
  return (
    <UiTypography
      data-testid={TEST_ID || 'title'}
      className={classNames('onboarding-title', className)}
      ref={ref}
      variant="title-medium"
      color={color}
      component="h2"
    >
      {children}
    </UiTypography>
  );
});
